import React, {useEffect} from 'react';
import {Link, useRouteMatch} from 'react-router-dom';
import CompanyList from './companyList/CompanyList';
import Search from './companyList/search/Search';
import {useSelector, useDispatch} from "react-redux";
import {selectCompanies} from "../../store/reducers/companiesReducer";
import {isHuriAdded} from '../../store/reducers/promoCodeReducer';
import { registrationSettingsSelector } from '../../store/reducers/registrationSettingsReducer';

function FindCompany() {
    const dispatch = useDispatch();
    const companies = useSelector(selectCompanies);
    const registrationData = useSelector(registrationSettingsSelector);

    let { path } = useRouteMatch();

    useEffect(() => {
        if(path.indexOf("huri") !== -1) {
            dispatch(isHuriAdded(true));
        }
      }, []); // eslint-disable-line

    return (
        <div className="registered_container first">
            <div>
                <h2>{registrationData.register_company_title}</h2>
            </div>
            <div className="search_container">
                <Search/>
                <p className="grey-p findCompany">{registrationData.register_company_description}</p>
            </div>
            {companies && (
                companies.length === 0
                    ? <div className="no-results">No results found</div>
                    : <CompanyList companies={companies}/>
            )}
            <div className="alreadyRegistered_link">
                <div>{registrationData.already_registered_text} <Link to="/alreadyRegistered">{registrationData.already_registered_link}</Link></div>
            </div>
        </div>
    );
}

export default FindCompany;
